import type { Client, Instance, MiniInstallation, ClientRecord, LicenseRecord } from "@/types";
import { getClientPaymentFromLicense, getClientStatusFromLicense, getLeaseDaysLeft, normalizeUiLeaseDays } from "@/lib/formatters";

export function buildClients(clients: ClientRecord[], licenses: LicenseRecord[], installations: MiniInstallation[]): Client[] {
  const clientSource: ClientRecord[] = clients.length
    ? clients
    : licenses.map((license) => ({
      id: license.clientId,
      name: license.clientName,
      owner: "",
      status: getClientStatusFromLicense(license.status, getLeaseDaysLeft(license.expiresAt || "")),
      licenseKey: license.key,
      licenseStatus: license.status,
      leaseDays: license.leaseDays,
      lastRenewedAt: license.lastRenewedAt,
      expiresAt: license.expiresAt,
    }));

  return clientSource.map((record) => {
    const license = licenses.find((item) => item.clientId === record.id) || null;
    const relatedInstances = installations.filter((instance) => instance.clientId === record.id);
    const licenseStatus = license?.status || record.licenseStatus || "none";
    const leaseDays = getLeaseDaysLeft(license?.expiresAt || record.expiresAt || "");
    return {
      id: record.id,
      name: record.name,
      owner: record.owner || "не указан",
      email: record.email || "",
      status: getClientStatusFromLicense(licenseStatus, leaseDays),
      instances: relatedInstances.length,
      leaseDays,
      leasePeriodDays: normalizeUiLeaseDays(license?.leaseDays || record.leaseDays),
      payment: getClientPaymentFromLicense(licenseStatus),
      key: record.licenseKey || license?.key || "",
      licenseStatus,
      expiresAt: license?.expiresAt || record.expiresAt || "",
    };
  });
}

export function buildInstances(installations: MiniInstallation[]): Instance[] {
  return installations.map((instance) => ({
    id: instance.id,
    clientId: instance.clientId,
    name: instance.name || instance.clientName,
    region: instance.serverName || instance.serverId || "server",
    status:
      instance.status === "running"
        ? "online"
        : instance.status === "missing" || instance.status === "stopped"
          ? "offline"
          : "deploying",
    version: instance.miniVersion || "unknown",
    cpu: 0,
    ram: 0,
    uptime: instance.health?.ok ? "online" : "-",
    mode: instance.aiAccountId ? "AI подключён" : "Без AI",
  }));
}
